import { render, staticRenderFns } from "./360DialogCloudWhatsapp.vue?vue&type=template&id=c2cda1c8&"
import script from "./360DialogCloudWhatsapp.vue?vue&type=script&lang=js&"
export * from "./360DialogCloudWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports